/* eslint-disable @typescript-eslint/no-namespace */
import { createContext } from 'react';

declare global {
  namespace NodeJS {
    interface ProcessEnv {
      NODE_ENV: 'development' | 'production';
    }
  }
}

interface TableContextProps {
  size: 'small' | 'medium' | 'xs';
}

const TableContext = createContext<TableContextProps | undefined>(undefined);

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

export { TableContext };

export default TableContext;
